/* tslint:disable */
/* eslint-disable */
/**
 * Shopping Cart API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FeesDto } from './FeesDto';
import {
    FeesDtoFromJSON,
    FeesDtoFromJSONTyped,
    FeesDtoToJSON,
    FeesDtoToJSONTyped,
} from './FeesDto';
import type { GuaranteeDto } from './GuaranteeDto';
import {
    GuaranteeDtoFromJSON,
    GuaranteeDtoFromJSONTyped,
    GuaranteeDtoToJSON,
    GuaranteeDtoToJSONTyped,
} from './GuaranteeDto';
import type { BorrowerPricingDto } from './BorrowerPricingDto';
import {
    BorrowerPricingDtoFromJSON,
    BorrowerPricingDtoFromJSONTyped,
    BorrowerPricingDtoToJSON,
    BorrowerPricingDtoToJSONTyped,
} from './BorrowerPricingDto';
import type { FunnelProductDto } from './FunnelProductDto';
import {
    FunnelProductDtoFromJSON,
    FunnelProductDtoFromJSONTyped,
    FunnelProductDtoToJSON,
    FunnelProductDtoToJSONTyped,
} from './FunnelProductDto';
import type { LoanInsuranceConfigDto } from './LoanInsuranceConfigDto';
import {
    LoanInsuranceConfigDtoFromJSON,
    LoanInsuranceConfigDtoFromJSONTyped,
    LoanInsuranceConfigDtoToJSON,
    LoanInsuranceConfigDtoToJSONTyped,
} from './LoanInsuranceConfigDto';
import type { ReadVariablesTunnelDto } from './ReadVariablesTunnelDto';
import {
    ReadVariablesTunnelDtoFromJSON,
    ReadVariablesTunnelDtoFromJSONTyped,
    ReadVariablesTunnelDtoToJSON,
    ReadVariablesTunnelDtoToJSONTyped,
} from './ReadVariablesTunnelDto';
import type { FunnelPricingDto } from './FunnelPricingDto';
import {
    FunnelPricingDtoFromJSON,
    FunnelPricingDtoFromJSONTyped,
    FunnelPricingDtoToJSON,
    FunnelPricingDtoToJSONTyped,
} from './FunnelPricingDto';

/**
 * 
 * @export
 * @interface BorrowerContractFunnelDto
 */
export interface BorrowerContractFunnelDto {
    /**
     * 
     * @type {string}
     * @memberof BorrowerContractFunnelDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerContractFunnelDto
     */
    name: string;
    /**
     * 
     * @type {FunnelProductDto}
     * @memberof BorrowerContractFunnelDto
     */
    product: FunnelProductDto;
    /**
     * 
     * @type {Array<FeesDto>}
     * @memberof BorrowerContractFunnelDto
     */
    fees?: Array<FeesDto>;
    /**
     * 
     * @type {Array<ReadVariablesTunnelDto>}
     * @memberof BorrowerContractFunnelDto
     */
    variables?: Array<ReadVariablesTunnelDto>;
    /**
     * 
     * @type {FunnelPricingDto}
     * @memberof BorrowerContractFunnelDto
     */
    pricing: FunnelPricingDto;
    /**
     * 
     * @type {Array<LoanInsuranceConfigDto>}
     * @memberof BorrowerContractFunnelDto
     */
    loanConfigs: Array<LoanInsuranceConfigDto>;
    /**
     * 
     * @type {Array<GuaranteeDto>}
     * @memberof BorrowerContractFunnelDto
     */
    guarantees: Array<GuaranteeDto>;
    /**
     * All available guarantees for this contract funnel
     * @type {Array<GuaranteeDto>}
     * @memberof BorrowerContractFunnelDto
     */
    guaranteesReferential?: Array<GuaranteeDto>;
    /**
     * 
     * @type {string}
     * @memberof BorrowerContractFunnelDto
     */
    supportId: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerContractFunnelDto
     */
    supportLabel: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerContractFunnelDto
     */
    contractIdentifier: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BorrowerContractFunnelDto
     */
    warningMessages: Array<string>;
    /**
     * 
     * @type {Array<BorrowerPricingDto>}
     * @memberof BorrowerContractFunnelDto
     */
    borrowers: Array<BorrowerPricingDto>;
    /**
     * 
     * @type {string}
     * @memberof BorrowerContractFunnelDto
     */
    hash?: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerContractFunnelDto
     */
    mncapBorrowerId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BorrowerContractFunnelDto
     */
    hasSelection?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BorrowerContractFunnelDto
     */
    isCasLemoine: boolean;
    /**
     * Match score percentage (0-100)
     * @type {number}
     * @memberof BorrowerContractFunnelDto
     */
    matchScore?: number;
    /**
     * List of missing guarantee identifiers
     * @type {Array<string>}
     * @memberof BorrowerContractFunnelDto
     */
    missingGuarantees?: Array<string>;
    /**
     * Cotisation type identifier (CI or CRD)
     * @type {string}
     * @memberof BorrowerContractFunnelDto
     */
    cotisationTypeId?: string;
    /**
     * Cotisation type label
     * @type {string}
     * @memberof BorrowerContractFunnelDto
     */
    cotisationTypeLabel?: string;
}

/**
 * Check if a given object implements the BorrowerContractFunnelDto interface.
 */
export function instanceOfBorrowerContractFunnelDto(value: object): value is BorrowerContractFunnelDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('product' in value) || value['product'] === undefined) return false;
    if (!('pricing' in value) || value['pricing'] === undefined) return false;
    if (!('loanConfigs' in value) || value['loanConfigs'] === undefined) return false;
    if (!('guarantees' in value) || value['guarantees'] === undefined) return false;
    if (!('supportId' in value) || value['supportId'] === undefined) return false;
    if (!('supportLabel' in value) || value['supportLabel'] === undefined) return false;
    if (!('contractIdentifier' in value) || value['contractIdentifier'] === undefined) return false;
    if (!('warningMessages' in value) || value['warningMessages'] === undefined) return false;
    if (!('borrowers' in value) || value['borrowers'] === undefined) return false;
    if (!('isCasLemoine' in value) || value['isCasLemoine'] === undefined) return false;
    return true;
}

export function BorrowerContractFunnelDtoFromJSON(json: any): BorrowerContractFunnelDto {
    return BorrowerContractFunnelDtoFromJSONTyped(json, false);
}

export function BorrowerContractFunnelDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerContractFunnelDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'product': FunnelProductDtoFromJSON(json['product']),
        'fees': json['fees'] == null ? undefined : ((json['fees'] as Array<any>).map(FeesDtoFromJSON)),
        'variables': json['variables'] == null ? undefined : ((json['variables'] as Array<any>).map(ReadVariablesTunnelDtoFromJSON)),
        'pricing': FunnelPricingDtoFromJSON(json['pricing']),
        'loanConfigs': ((json['loanConfigs'] as Array<any>).map(LoanInsuranceConfigDtoFromJSON)),
        'guarantees': ((json['guarantees'] as Array<any>).map(GuaranteeDtoFromJSON)),
        'guaranteesReferential': json['guaranteesReferential'] == null ? undefined : ((json['guaranteesReferential'] as Array<any>).map(GuaranteeDtoFromJSON)),
        'supportId': json['supportId'],
        'supportLabel': json['supportLabel'],
        'contractIdentifier': json['contractIdentifier'],
        'warningMessages': json['warningMessages'],
        'borrowers': ((json['borrowers'] as Array<any>).map(BorrowerPricingDtoFromJSON)),
        'hash': json['hash'] == null ? undefined : json['hash'],
        'mncapBorrowerId': json['mncapBorrowerId'] == null ? undefined : json['mncapBorrowerId'],
        'hasSelection': json['hasSelection'] == null ? undefined : json['hasSelection'],
        'isCasLemoine': json['isCasLemoine'],
        'matchScore': json['matchScore'] == null ? undefined : json['matchScore'],
        'missingGuarantees': json['missingGuarantees'] == null ? undefined : json['missingGuarantees'],
        'cotisationTypeId': json['cotisationTypeId'] == null ? undefined : json['cotisationTypeId'],
        'cotisationTypeLabel': json['cotisationTypeLabel'] == null ? undefined : json['cotisationTypeLabel'],
    };
}

export function BorrowerContractFunnelDtoToJSON(json: any): BorrowerContractFunnelDto {
    return BorrowerContractFunnelDtoToJSONTyped(json, false);
}

export function BorrowerContractFunnelDtoToJSONTyped(value?: BorrowerContractFunnelDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'product': FunnelProductDtoToJSON(value['product']),
        'fees': value['fees'] == null ? undefined : ((value['fees'] as Array<any>).map(FeesDtoToJSON)),
        'variables': value['variables'] == null ? undefined : ((value['variables'] as Array<any>).map(ReadVariablesTunnelDtoToJSON)),
        'pricing': FunnelPricingDtoToJSON(value['pricing']),
        'loanConfigs': ((value['loanConfigs'] as Array<any>).map(LoanInsuranceConfigDtoToJSON)),
        'guarantees': ((value['guarantees'] as Array<any>).map(GuaranteeDtoToJSON)),
        'guaranteesReferential': value['guaranteesReferential'] == null ? undefined : ((value['guaranteesReferential'] as Array<any>).map(GuaranteeDtoToJSON)),
        'supportId': value['supportId'],
        'supportLabel': value['supportLabel'],
        'contractIdentifier': value['contractIdentifier'],
        'warningMessages': value['warningMessages'],
        'borrowers': ((value['borrowers'] as Array<any>).map(BorrowerPricingDtoToJSON)),
        'hash': value['hash'],
        'mncapBorrowerId': value['mncapBorrowerId'],
        'hasSelection': value['hasSelection'],
        'isCasLemoine': value['isCasLemoine'],
        'matchScore': value['matchScore'],
        'missingGuarantees': value['missingGuarantees'],
        'cotisationTypeId': value['cotisationTypeId'],
        'cotisationTypeLabel': value['cotisationTypeLabel'],
    };
}

